/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// // *From Auth - Data will be received from auth provider
// const userDefaults = {
//   uid         : 0,          // From Auth
//   displayName : "John Doe", // From Auth
//   about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
//   photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
//   status      : "online",
//   userRole    : "admin"
// }

// // Check if device is touch device
// // This is used to remove perfect scrollbar from touch devices
// // Using Dynamic components
// const is_touch_device = () => {
//   var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
//   var mq = function(query) {
//       return window.matchMedia(query).matches;
//   }

//   if (('ontouchstart' in window) || window.DocumentTouch) {
//       return true;
//   }

//   // include the 'heartz' as a way to have a non matching MQ to help terminate the join
//   // https://git.io/vznFH
//   var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
//   return mq(query);
// }

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  returnEnable: false,
  navEnable:false,
  product1List: [],
  product2List: [],
  solutionList: ["家庭管路解决方案", "家庭管路计量方案", "......"],
  newsList: [
    { title: "新闻与活动", url: "/news" },
    { title: "产品资讯", url: "/news12" },
    { title: "展会活动", url: "/news13" },
    { title: "最新公告", url: "/news14" },
  ],
  mediaList: [
    { title: "VR展示", url: "/news2" },
    { title: "企业视频", url: "/news3" },
    { title: "媒体图库", url: "/news4" },
    { title: "宣传资料", url: "/news5" },],
    bandList1: [
      { title: "天鑫介绍", url: "/about" },
      { title: "天鑫文化", url: "/about" },
      { title: "发展历程", url: "/study" },
      { title: "技术研发", url: "/study" },
      { title: "质量管控", url: "/production" },
      { title: "精益生产", url: "/aboutteam" },
      { title: "精英团队", url: "/aboutteam" },
    ],
    bandList2: [
      { title: "合作伙伴", url: "/aboutteam" },
      { title: "客户服务", url: "/aboutteam" },
      { title: "企业荣誉", url: "/aboutteam" },
    ],
      zhaoxianList: [
        { title: "技术工程师", url: "/joinus" },
        { title: "检验员", url: "/joinus" },
        { title: "数控", url: "/joinus" },
        { title: "普工", url: "/joinus" },],
    contactList: [
      { title: "采购", url: "/contact" },
      { title: "咨询", url: "/contact" },],
      supportList: [
        { title: "管件技术支持", url: "" },
        { title: "仪表技术支持", url: "" },],
  about: [
    "天鑫介绍",
    "天鑫文化",
    "发展历程",
    "技术研发",
    "质量管控",
    "精益生成",
    "精英团队",
  ],
  media: ["VR展示", "企业视频", "媒体图库", "宣传资料"],
  colarrowdown:
    "https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/col-arrow-down.png",
  colarrowup:
    "https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/col-arrow-up.png",

  



  // ************
  // **页面参数***
  // ************
  pageTitle:'',
  pageKey:'',
  pageDesc:'',

  pageContent:{},

  navbarContent:{},
  footerContent:{},

  productcategorys:[],
  allproductcategorys:[],

  products:[],
  productstotal:0,


  leftproductimg:'',
  rightproductimg:'',


pwd:'',
loginpath:'',
loginmode:'',

  // user                    : {},
  // online                  :0,
  // AppActiveUser           : userDefaults,
  // bodyOverlay             : false,
  // isVerticalNavMenuActive : true,
  // is_touch_device         : is_touch_device(),
  // mainLayoutType          : themeConfig.mainLayoutType || "vertical",
  // navbarSearchAndPinList  : navbarSearchAndPinList,
  // reduceButton            : themeConfig.sidebarCollapsed,
  // verticalNavMenuWidth    : "default",
  // verticalNavMenuItemsMin : false,
  // scrollY                 : 0,
  // starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  // theme                   : themeConfig.theme || "light",
  // themePrimaryColor       : colors.primary,

  // // Can be used to get current window with
  // // Note: Above breakpoint state is for internal use of sidebar & navbar component
  // windowWidth: null,

  // // 常用数据
  // localeText,
  // orgs                    :JSON.parse(localStorage.getItem("orgs"))||[],
  // selectedorg             :{},
  // icons,
  // selectedIcon            :{},
  // forms                   :JSON.parse(localStorage.getItem("forms"))||[],
  // selectedForm            :{},
  // roles                   :JSON.parse(localStorage.getItem("roles"))||[],
  // selectedRole            :{},
  // menus                   :JSON.parse(localStorage.getItem("menus"))||[],
  // selectedMenu            :{},
  // goodscategorys          :JSON.parse( localStorage.getItem("goodscategorys"))||[],
  // notifications:[],
};

export default state;
